/**
 * Ad Bottom Sticky Bar
 * Shows/hides the bottom sticky bar on mobile when scrolling past the seller widget
 */

$(document).ready(function () {
  const $adBottomBar = $(".pad-bottom-bar");
  const $mobileSellerWidget = $("#mobile-seller-widget");

  // Only run on mobile and if elements exist
  if (!$adBottomBar.length || !$mobileSellerWidget.length) {
    return;
  }

  // Check if we're on mobile (md breakpoint = 768px)
  function isMobile() {
    return window.innerWidth < 768;
  }

  $(window).on("scroll", function () {
    if (!isMobile()) {
      $adBottomBar.removeClass("is-visible");
      return;
    }

    const widgetBottom =
      $mobileSellerWidget.offset().top + $mobileSellerWidget.outerHeight();
    const scrollTop = $(window).scrollTop();

    if (scrollTop > widgetBottom) {
      $adBottomBar.addClass("is-visible");
    } else {
      $adBottomBar.removeClass("is-visible");
    }
  });

  // Also check on resize
  $(window).on("resize", function () {
    if (!isMobile()) {
      $adBottomBar.removeClass("is-visible");
    }
  });
});
